export default __webpack_public_path__ + "static/media/Gallery1.8d3da479.jpg";